/*
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  SPDX-License-Identifier: MIT-0 
*/

export default {
  setUsername(
    context: { commit: (arg0: string, arg1: string) => void },
    payload: string
  ): void {
    context.commit("setUsername", payload);
  },
  setEmail(
    context: { commit: (arg0: string, arg1: string) => void },
    payload: string
  ): void {
    context.commit("setEmail", payload);
  },
  setGivenName(
    context: { commit: (arg0: string, arg1: string) => void },
    payload: string
  ): void {
    context.commit("setGivenName", payload);
  },
  setFamilyName(
    context: { commit: (arg0: string, arg1: string) => void },
    payload: string
  ): void {
    context.commit("setFamilyName", payload);
  },
  setStationCode(
    context: { commit: (arg0: string, arg1: string) => void },
    payload: string
  ): void {
    context.commit("setStationCode", payload);
  },
  setCompanyName(
    context: { commit: (arg0: string, arg1: string) => void },
    payload: string
  ): void {
    context.commit("setCompanyName", payload);
  },
  setTitle(
    context: { commit: (arg0: string, arg1: string) => void },
    payload: string
  ): void {
    context.commit("setTitle", payload);
  },
  setDepartment(
    context: { commit: (arg0: string, arg1: string) => void },
    payload: string
  ): void {
    context.commit("setDepartment", payload);
  },
};
